import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import eventBus from "../../../event-bus/eventBus";

const saveEstimate = {
    namespaced: true,
    state: {
        isSaving: false,
        modalInfo: {
            typeInfo: "",
            isShow: false,
            text: "",
            head: ""
        }
    },
    mutations: {
        STORE_ESTIMATE_SUCCESS(state, response) {
            state.modalInfo.typeInfo = "success";
            state.modalInfo.isShow = true;
            state.modalInfo.text = response.data.data.textInfo;
            state.modalInfo.head = response.data.message;
            eventBus.$emit('saveEstimateSuccess');
        },
        STORE_ESTIMATE_FAILURE(state, error) {
            state.modalInfo.typeInfo = "error";
            state.modalInfo.isShow = true;
            state.modalInfo.head = "Error";
            state.modalInfo.text = error.toString();

            console.log(error);
        },
        HIDE_MODAL(state) {
            state.modalInfo.isShow = false;
        }
    },
    actions: {
        storeEstimate: function({ dispatch, state }, payload) {
            let url = new URL(window.location.href);
            payload.creds.projectId = url.searchParams.get("id");
            state.isSaving = true;
            let promise = sendRequest("post", config.baseURLApi + "/estimates", {}, payload.creds);
            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successStoreEstimate", result[1]);
                } else {
                    dispatch("failureStoreEstimate", result[1]);
                }
                state.isSaving = false;
            })
        },
        successStoreEstimate: function({ commit }, response) {
            commit("STORE_ESTIMATE_SUCCESS", response);
        },
        failureStoreEstimate: function({ commit }, error) {
            commit("STORE_ESTIMATE_FAILURE", error);
        },
        hideModal: function({ commit }) {
            commit("HIDE_MODAL");
        }
    }
}
export default saveEstimate;